<template>
    <div class="module" id="saleService">
        <ScrollList class="service" :items="items" :cols="8" :control="control">
            <template v-slot:default="{card}">
                <h4>{{card.name}}</h4>
                <b-card-text class="desc" :title="card.desc" v-html="card.desc">
                </b-card-text>
            </template>
        </ScrollList>
    </div>
</template>

<script>
    import ScrollList from './ScrollList'

    export default {
        name: 'List',
        props: {
            items: Array,
        },
        data() {
          return {
              control: true,
          }
        },
        components: {
            ScrollList,
        },
        methods: {
            handleScroll(direction) {
                const row = document.getElementById('saleService')
                if (direction === 'left') {
                    //row.scrollLeft = row.clientWidth
                    this.animate(row, 0)
                } else {
                    //row.scrollLeft = row.clientWidth
                    this.animate(row, row.scrollWidth - row.clientWidth)
                }
            },
            animate(ele, target) {
                //1.清除定时器并设置定时器函数
                clearInterval(ele.timer)
                ele.timer = setInterval(function () {
                    //2.处理步长
                    let step = (target - ele.scrollLeft) / 10
                    step = step > 0 ? Math.ceil(step) : Math.floor(step)
                    //3.if函数判断当前位置
                    if (Math.abs(target - ele.scrollLeft) <= Math.abs(step)) {
                        ele.scrollLeft = target
                        clearInterval(ele.timer)
                    } else {
                        ele.scrollLeft = ele.scrollLeft + step
                    }
                }, 20)
            }
        }
    }
</script>

<style lang="less" scoped>
    .en {
        .module /deep/ h4 {
            font-size: 18px !important;
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
        }

        .module /deep/ .card-text {
            font-size: 16px !important;
        }
    }

    .module /deep/ .list {
        .list-item {
            flex-wrap: wrap;
        }
    }

    .module {
        position: relative;
    }

    .redirect {
        position: absolute;
        top: 50%;
        right: 0;
        z-index: 100;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
        background-image: url("../../../assets/img/common/arrow_right.png");
        background-size: 100%;
    }

    .module /deep/ h4 {
        margin-top: 12px;
        margin-bottom: 15px;
        font-size: 18px;
        line-height: 27px;
        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
    }

    .module /deep/ .desc {
        margin-bottom: 30px !important;
        font-size: 14px;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: justify;
    }

    .service {
        margin-top: 0 !important;
        /deep/ .control {
            &.left {
                top:50% !important;
            }

            &.right {
                top:50% !important;
            }
        }

        /deep/ .card {
            position: relative;

            .card-body {
                text-align: center;
                height: 0 !important;
                padding: 0 !important;

                h4 {
                    position: absolute;
                    bottom: 40px;
                    left: 40px;
                    font-size: 18px;
                    line-height: 27px;
                    margin: 0;
                    color: #fff;
                }

                p {
                    margin: 0;
                    font-size: 14px;
                    line-height: 28px;
                    text-align: center;

                    a {
                        color: #000;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
